var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIconNum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.64516 10H2.32258V2.5H0V0H4.64516V10ZM14.7097 7.5H10.0645V5.83333H13.1613C14.0129 5.83333 14.7097 5.08333 14.7097 4.16667V1.66667C14.7097 0.75 14.0129 0 13.1613 0H7.74194V2.5H12.3871V4.16667H9.29032C8.43871 4.16667 7.74194 4.91667 7.74194 5.83333V10H14.7097V7.5ZM24 8.33333V1.66667C24 0.75 23.3032 0 22.4516 0H17.0323V2.5H21.6774V4.16667H18.5806V5.83333H21.6774V7.5H17.0323V10H22.4516C23.3032 10 24 9.25 24 8.33333Z",
    fill: "#3F4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconNum);
export default __webpack_public_path__ + "static/media/filter_icon_num.6b04c7993142f19eaf8e7469b2288687.svg";
export { ForwardRef as ReactComponent };